<template>
  <div class="container">
    <m-row>
      <m-col lg="3">
        <memlist-date-picker
          v-model="date_from"
          class="mt-4"
          :placeholder="$t('MEMBER_RENEW.DATE_FROM')"
        />
      </m-col>
      <m-col lg="3">
        <memlist-date-picker
          v-model="date_to"
          class="mt-4"
          :placeholder="$t('MEMBER_RENEW.DATE_TO')"
        />
      </m-col>
      <m-col lg="6">
        <Multiselect
          style="margin-top: 14px;"
          class="multiselect-blue"
          v-model="campaign_ids"
          ref="campaigns_multiselect"
          mode="tags"
          :placeholder="$t('MEMBER_RENEW.CAMPAIGNS')"
          :close-on-select="false"
          :filter-results="false"
          :min-chars="0"
          :resolve-on-load="false"
          :delay="0"
          :searchable="true"
          :options="async function(query) {
            return await fetch_campaign_options(query);
          }"
        />
        
      </m-col>
    </m-row>

    <m-row>
      <m-col lg="12">
        <MemlistLineChart
          :labels="week_labels"
          :datasets="[
            { label: 'Förnyade',  data: renewal_all_data, color: '#4f46e5' /*, markers: [ {label:'March', text:'Deploy'}] */ },
            /*{ label: 'Clicks', data: [20,22,18,34,28,40,38], color: '#06b6d4' }*/
          ]"
          :title="$t('MEMBER_RENEW.RENEWAL_OVER_TIME')"
        />
      </m-col>
    </m-row>

    <m-row class="align-top mt-8">
      <m-col lg="4" class="col-top">
        <MemlistDoughnutChart
          :values="done_not_done_data"
          :labels="[$t('MEMBER_RENEW.SHORT_DONE'),$t('MEMBER_RENEW.SHORT_NOT_DONE')]"
          :colors="['#10b981', '#ef4444' ]"
          :center="{ label: $t('MEMBER_RENEW.RENEWED_PCT'), value: done_pct_label }"
          :styles="{ alignSelf: 'flex-start', width: '100%', maxWidth: '300px', }"
        />
      </m-col>
      
      <m-col lg="4" class="col-top">
        <MemlistDoughnutChart
          :values="method_data"
          :labels="['Via SMS', 'Via E-post', 'Via Mina Sidor', 'Manuell']"
          :colors="['#4f46e5', '#10b981', '#ef4444', '#ef4444']"
          :center="{ label: 'Metod', value: done_renews_total }"
          :styles="{ alignSelf: 'flex-start', width: '100%', maxWidth: '300px',  }"
        />
      </m-col>

      <m-col lg="4" class="col-top">
        <MemlistDoughnutChart
          :values="[]"
          :labels="[]"
          :colors="['#4f46e5', '#10b981', '#ef4444']"
          :center="{ label: '...', value: 0 }"
          :styles="{ alignSelf: 'flex-start', width: '100%', maxWidth: '300px',  }"
        />
      </m-col>
    </m-row>

    <m-row>
      <m-col lg="12">
        <MemlistBarChart
          :title="$t('MEMBER_RENEW.PER_COMPANY_TITLE') || 'Förnyelser per förening'"
          x-axis-label="Förening"
          :y-axis-label="barIsPercent ? 'Andel (%)' : 'Antal'"
          :labels="barLabelsPerCompany"
          :datasets="barDatasetsPerCompany"
        />
      </m-col>
    </m-row>
  </div>
</template>

<script>
import axios from 'axios'
import MemlistDoughnutChart from '@/view/pages/ml/sendout/MemlistDoughnutChart.vue'
import MemlistLineChart from '@/view/pages/ml/sendout/MemlistLineChart.vue'
import MemlistBarChart from '@/view/pages/ml/sendout/MemlistBarChart.vue'
import Multiselect from '@vueform/multiselect/dist/multiselect.vue2.js'
import { mapGetters } from 'vuex';

export default {
  name: 'RenewGraphs',
  components: { 
    MemlistDoughnutChart, 
    MemlistLineChart, 
    MemlistBarChart, 
    Multiselect,
  },

  data() {
    return {
      campaigns: [],
      campaign_ids: [],
      timeline: {
        per_week_data: [],
        week_span: 0,
        from: null,
        to: null,
      },
      summary: { sms_3:0, sms_2:0, sms_1:0, email:0, member_profile:0, done:0, not_done:0 },
      per_company: {},     // { company_id: { done, not_done, name, company_id } }
      date_from: null,
      date_to: null,

      // Toggle this if you want the bar to show % instead of counts
      barIsPercent: false
    }
  },

  async mounted() {

    setTimeout(async ()=>{
      this.set_dates_from_period(this.currentPeriodId);

      await this.reload();
      await this.fetch_campaigns();

      if (this.$refs.campaigns_multiselect) {
        this.$refs.campaigns_multiselect.refreshOptions()
      }
    
    },500);

    
  },

  watch: {
    date_from: 'reload',
    date_to: 'reload',

    currentPeriodId() {
      this.set_dates_from_period(this.currentPeriodId);
    }
  },

  methods: {
    set_dates_from_period(id) {
      console.log('finding period', id, this.periods);
      const period = this.periods.find(i => i.id === id);

      if (period.is_infinite) {
        this.date_from = dayjs().subtract(365, 'days').format('YYYY-MM-DD');
        this.date_to = dayjs().format('YYYY-MM-DD');
      }
      else {
        this.date_from = period.from;
        this.date_to = period.to;
      }

      console.log('dates set', this.date_from, this.date_to);
      
    },
    async fetch_campaigns() {
      const res = await axios.get(`/member_renew/campaigns`);

      if (res.status === 200) {
        this.campaigns = res.data;
      }
    },

    async fetch_campaign_options(query) {
      if (!this.campaigns?.length) {
        return []
      }

      let res_campaigns = [...this.campaigns];

      if (query?.length) {
        res_campaigns = this.campaigns.filter(item => item.name.toLowerCase().includes(query?.toLowerCase()));
      }

      return res_campaigns.map(item => ({ label: item.name, value: item.id }));
    },
    async reload() {
      const from = this.date_from || ''
      const to   = this.date_to   || ''
      this.timeline    = await this.fetch_timeline(from, to);
      this.summary     = await this.fetch_summary(from, to);
      this.per_company = await this.fetch_percent_per_company(from, to)
    },

    async fetch_timeline(from, to) {
      // NOTE: your earlier code had ?to_date= — standardize on ?to=
      const res = await axios.get(`/member_renew/timeline`, { params: { from, to } })
      return res.status === 200 ? res.data : []
    },

    async fetch_summary(from, to) {
      const res = await axios.get(`/member_renew/summary`, { params: { from, to } })
      return res.status === 200
        ? res.data
        : { sms_3:0, sms_2:0, sms_1:0, email:0, member_profile:0, done:0, not_done:0 }
    },

    async fetch_percent_per_company(from, to) {
      const res = await axios.get(`/member_renew/percent/companies`, { params: { from, to } })
      return res.status === 200 ? res.data : {}
      /**
       * Expected shape:
       * {
       *   "company_id1": { done: 12, not_done: 22, name: "Förening A", company_id: "company_id1" },
       *   "company_id2": { done: 5,  not_done:  3, name: "Förening B", company_id: "company_id2" }
       * }
       */
    }
  },

  computed: {
    ...mapGetters([
      'currentCompanyId',
      'currentPeriodId',
      'currentUserId',
      'companies',
      'periods',
      'profile',
      'settings',
      'isTHS',
      'sid'
    ]),

    done_pct_label() {
      if ((this.summary.not_done + this.summary.done) === 0) {
        return '-';
      }

      return Math.round( ( this.summary.done / (this.summary.not_done + this.summary.done)) * 100) + '%';
    },
    done_renews_total() {
      return this.summary.done;
    },
    method_data() {

      const manual = this.summary.done - (this.summary.sms_3 + this.summary.sms_2 + this.summary.sms_1 + this.summary.email + this.summary.member_profile );

      return [this.summary.sms_3 + this.summary.sms_2 + this.summary.sms_1, this.summary.email, this.summary.member_profile, manual ];
    },
    done_not_done_totals() {
      return this.summary.done + this.summary.not_done;
    },
    done_not_done_data() {
      return [this.summary.done, this.summary.not_done];
    },
    renewal_all_data() {
      return this.timeline.per_week_data.map(i => (i.cnt));
    },
    week_labels() {
      return this.timeline.per_week_data.map(i => (i.week_start));
    },
    // Turn the object into a sorted array (by done desc)
    perCompanyRows() {
      const rows = Object.values(this.per_company || {})
      rows.sort((a, b) => (b?.done || 0) - (a?.done || 0))
      return rows
    },

    barLabelsPerCompany() {
      return this.perCompanyRows.map(r => r.name || r.company_id || '—')
    },

    barDatasetsPerCompany() {
      // If barIsPercent = true: convert to percentages; else raw counts
      const done = []
      const notDone = []

      for (const r of this.perCompanyRows) {
        const d = Number(r?.done || 0)
        const n = Number(r?.not_done || 0)
        if (this.barIsPercent) {
          const t = d + n
          const pctDone = t > 0 ? Math.round((d / t) * 100) : 0
          const pctNot  = t > 0 ? Math.round((n / t) * 100) : 0
          done.push(pctDone)
          notDone.push(pctNot)
        } else {
          done.push(d)
          notDone.push(n)
        }
      }

      return [
        {
          label: this.barIsPercent ? 'Klart (%)' : 'Klart',
          data: done,
          backgroundColor: 'rgba(16, 185, 129, 0.85)',  // emerald
          borderColor: 'rgba(16, 185, 129, 1)'
        },
        {
          label: this.barIsPercent ? 'Ej klart (%)' : 'Ej klart',
          data: notDone,
          backgroundColor: 'rgba(239, 68, 68, 0.85)',   // red
          borderColor: 'rgba(239, 68, 68, 1)'
        }
      ]
    }
  }
}
</script>

<style scoped>
.multiselect-blue {
  --ms-tag-bg: #DBEAFE;
  --ms-tag-color: #2563EB;
}

</style>